"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Queue {
    constructor({ process, aborted }) {
        this.closed = false;
        this.events = [];
        this._processing = false;
        this.enqueue = (event) => {
            if (this.closed)
                return;
            this.events.push(event);
            this._dequeue();
        };
        this.abort = (reason) => {
            this.closed = true;
            if (this.aborted) {
                this.aborted(reason);
            }
        };
        this._dequeue = () => {
            if (this._processing)
                return;
            if (this.closed)
                return;
            const event = this.events.shift();
            if (!event)
                return;
            this._processing = true;
            this.process(event)
                .then(() => {
                // console.log(cont);
            })
                .catch((err) => {
                this.closed = true;
                console.error(event, err);
            })
                .finally(() => {
                this._processing = false;
                this._dequeue();
            });
        };
        this.process = process;
        this.aborted = aborted;
    }
}
exports.default = Queue;
//# sourceMappingURL=Queue.js.map